import { useRef } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { Loader2, Upload } from 'lucide-react';
import { useLanguage } from '@/i18n/LanguageContext';

export const CsvImportDialog = ({
  open, onOpenChange,
  classes, csvClassId, setCsvClassId,
  csvFile, setCsvFile,
  importing, onImport, onCancel,
}) => {
  const { t } = useLanguage();
  const fileInputRef = useRef(null);

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-card border-border">
        <DialogHeader>
          <DialogTitle>{t('students.importCsv')}</DialogTitle>
          <DialogDescription className="sr-only">
            {t('students.importCsvDesc')}
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-4 mt-4">
          <p className="text-sm text-muted-foreground">{t('students.importCsvDesc')}</p>
          <div className="p-3 bg-muted/50 rounded-sm">
            <p className="text-xs font-mono text-muted-foreground">{t('students.csvFormat')}</p>
            <p className="text-xs font-mono text-muted-foreground mt-1">name</p>
            <p className="text-xs font-mono text-muted-foreground">Max Müller</p>
            <p className="text-xs font-mono text-muted-foreground">Anna Schmidt</p>
          </div>
          <div className="space-y-2">
            <Label>{t('students.selectClass')}</Label>
            <Select value={csvClassId} onValueChange={setCsvClassId}>
              <SelectTrigger className="bg-secondary border-border" data-testid="csv-class-select">
                <SelectValue placeholder={t('students.selectClass')} />
              </SelectTrigger>
              <SelectContent className="bg-card border-border">
                {classes.map((cls) => (
                  <SelectItem key={cls.class_id} value={cls.class_id}>
                    {cls.name} ({cls.year})
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>
          <div className="space-y-2">
            <Label>{t('students.selectFile')}</Label>
            <Input
              ref={fileInputRef}
              type="file"
              accept=".csv,.txt"
              onChange={(e) => {
                const files = e.target.files;
                setCsvFile(files && files.length > 0 ? files[0] : null);
              }}
              className="bg-secondary border-border"
              data-testid="csv-file-input"
            />
          </div>
          <div className="flex justify-end gap-3">
            <Button variant="outline" onClick={onCancel}>{t('common.cancel')}</Button>
            <Button
              onClick={onImport}
              disabled={importing || !csvFile || !csvClassId}
              className="bg-primary hover:bg-primary/90"
              data-testid="csv-import-submit"
            >
              {importing ? <Loader2 className="w-4 h-4 mr-2 animate-spin" /> : <Upload className="w-4 h-4 mr-2" />}
              {importing ? t('students.importing') : t('students.importCsv')}
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};
